<div class="executed-container mt-3">
  <div class="executed__data-container">
    <div class="strong font-18 mb-3">{{ executionInfoHeader }}</div>
    <ng-container
      *ngIf="adjustment.status === 'Uitgesteld'; else notDelayedInfo"
    >
      {{ adjustment.delayedReason }}
    </ng-container>
    <ng-template #notDelayedInfo>
      <ng-container
        *ngIf="
          !notExecuted && !showNotExecutedHistoryItemInfo;
          else notExecutedDisplay
        "
      >
        <div>
          <span class="strong">Installateur: </span>
          <span>{{ placerNames | or }}</span>
        </div>
        <div class="mb-3">
          <span class="strong">{{ executionInfoDateLabel }}: </span>
          <span>{{ executionInfoDateDisplay | or }}</span>
        </div>
      </ng-container>
      <ng-template #notExecutedDisplay>
        <ng-container *ngIf="notExecutedHistoryItem != null">
          <div class="d-flex">
            <div class="author-display">
              <div *ngIf="notExecutedHistoryItem.author != null">
                {{
                  notExecutedHistoryItem.author.firstName
                    | personName: notExecutedHistoryItem.author.lastName
                }}
              </div>
              <div *ngIf="notExecutedHistoryItem.createdTimestamp != null">
                {{
                  notExecutedHistoryItem.createdTimestamp
                    | formatDate: '':'dd/MM/yyyy'
                }}
              </div>
            </div>
            <div class="content-display">
              <p>{{ notExecutedHistoryItem.onlineInfo }}</p>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-template>
  </div>
  <div class="executed__image-container">
    <img
      *ngIf="adjustmentExecutionAssets?.length > 0"
      class="max-summary-width max-summary-height clickable"
      src="/api/assets/{{ adjustmentExecutionAssets[0].uuid }}"
      (click)="openAdjustmentExecutionAssetsLightbox()"
    />
  </div>
</div>
